import { create } from 'zustand';

interface RestoreDataState {
    restoreData: Record<string, any>;
    contains: (key: string) => boolean;
    get: (key: string) => any | undefined;
    set: (key: string, value: any) => void;
    clear: (key: string) => void;
    clearWithScreenId: (pageId: string) => void;
    clearAll: () => void;
}

export const useRestoreDataStore = create<RestoreDataState>((set, get) => ({
    restoreData: {},
    contains: (key: string) => {
        const restoreData = get().restoreData;
        return Object.prototype.hasOwnProperty.call(restoreData, key);
    },
    get: (key: string) => {
        return get().restoreData[key];
    },
    set: (key: string, value: any) => {
        set((state) => {
            return {
                restoreData: {
                    ...state.restoreData,
                    [key]: value,
                },
            };
        });
    },
    clear: (key: string) => {
        set((state) => {
            const next = { ...state.restoreData };
            delete next[key];
            return {
                restoreData: { ...next },
            };
        });
    },

    /**
     *
     * @param id 화면ID
     */
    clearWithScreenId: (id: string) => {
        set((state) => {
            const prefix = `${id}`;
            const restoreData = Object.fromEntries(
                Object.entries(state.restoreData).filter(([key]) => !key.startsWith(prefix)),
            );

            return { restoreData };
        });
    },

    clearAll: () => {
        set(() => {
            return {
                restoreData: {},
            };
        });
    },
}));
